import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./navbar.css";

const Navbar = () => {
    const { pathname } = useLocation();
    const [ active, setActive ] = useState(false);

    useEffect(()=> {
        window.addEventListener("resize", () => {
            if(window.innerWidth > 1023){
                setActive(false);
            }
        });
    }, []);

    return (
        <nav className={`app__navbar ${active ? "-active" : ""}`}>
            <div className="app__navbar-container">
                <div className="app__navbar-row d-flex flex-item-between">
                    <div className="app__navbar-logo">
                        <Link to="/">
                            <span> EA10-Lite </span>
                        </Link>
                    </div>

                    <ul className="app__navbar-items d-flex flex-item-center gap-2">
                        <li>
                            <Link 
                                to="/" 
                                className={pathname === "/" ? "-active": ""}
                                onClick={()=> setActive(false)}
                            >
                                <span> Home </span>
                            </Link>
                        </li>
                        <li>
                            <Link 
                                to="/about" 
                                className={pathname === "/about" ? "-active": ""}
                                onClick={()=> setActive(false)}
                            >
                                <span> About Me </span>
                            </Link>
                        </li>
                        <li>
                            <Link 
                                to="/experience" 
                                className={pathname === "/experience" ? "-active": ""}
                                onClick={()=> setActive(false)}
                            >
                                <span> Experience </span>
                            </Link>
                        </li>
                        <li>
                            <Link 
                                to="/portfolio" 
                                className={pathname === "/portfolio" ? "-active": ""}
                                onClick={()=> setActive(false)}
                            >
                                <span> Portfolio </span>
                            </Link>
                        </li>
                    </ul>

                    <div className="app__navbar-btns">
                        <Link to="/resume" className={`app__navbar-btn ${pathname === "/resume" ? "-active" : "" }`} onClick={() => setActive(false)}>
                            <span> Resume </span>
                        </Link>
                    </div>

                    <div className="app__navbar-mobile_menu" onClick={() => setActive(!active)}>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Navbar;